import oAuthRequest from "./oauthRequest"

// Import lists for large credentials can exceed the default 20s axios timeout
// (Network shows the request as "canceled"). Keep other calls at 20s.
const MESSAGES_LIST_TIMEOUT_MS = 60000

export const topics = () => {
  return oAuthRequest.get('/api/v1/messages/topics')
}

export const index = (kind, page, ioCredentialId) => {
  return oAuthRequest.get('/api/v1/messages', {
    params: {
      kind: kind, page: page, io_credential_id: ioCredentialId
    },
    timeout: MESSAGES_LIST_TIMEOUT_MS
  })
}

export const redo = (messageId) => {
  return oAuthRequest.post(`/api/v1/messages/${messageId}/redo`)
}

export const show = (messageId) => {
  return oAuthRequest.get(`/api/v1/messages/${messageId}`)
}

export const search = (kind, page, ioCredentialId, searchParams) => {
  const params = {
    kind: kind,
    page: page,
    io_credential_id: ioCredentialId,
    topic: searchParams.topic,
    status: searchParams.status,
    start_date: searchParams.start_date,
    end_date: searchParams.end_date,
    search: searchParams.search
  };
  return oAuthRequest.get("/api/v1/messages", {
    params,
    timeout: MESSAGES_LIST_TIMEOUT_MS
  });
};
